import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL + '/settings';

/**
 * Rates used if the backend is unreachable. These match the values that were
 * hardcoded across the apps before the rates became configurable, so an outage
 * degrades to the old behaviour instead of charging nothing.
 */
export const FALLBACK_HANDLING_RATE = {
  inStateRatePerKg: 3,
  outOfStateRatePerKg: 5,
  homeState: "Odisha",
};

export const fetchHandlingRate = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/handling-rate`);
    return response.data?.data || FALLBACK_HANDLING_RATE;
  } catch (error) {
    console.error("Error fetching handling rate, falling back to defaults:", error);
    return FALLBACK_HANDLING_RATE;
  }
};

export const updateHandlingRate = async (handlingRate) => {
  try {
    const response = await axios.put(`${BASE_URL}/handling-rate`, handlingRate);
    return response.data;
  } catch (error) {
    console.error("Error updating handling rate:", error);
    throw error;
  }
};

/**
 * Rupees-per-kg that applies to a given shipping state.
 * Falls back to the out-of-state rate when the state cannot be determined,
 * so an unparseable address never silently produces a zero charge.
 */
export const resolveRatePerKg = (shippingState, handlingRate) => {
  const rate = handlingRate || FALLBACK_HANDLING_RATE;
  const normalisedState = (shippingState || "").trim().toLowerCase();
  const homeState = (rate.homeState || "").trim().toLowerCase();

  return normalisedState && normalisedState === homeState
    ? Number(rate.inStateRatePerKg)
    : Number(rate.outOfStateRatePerKg);
};
